import {
  MANAGE_RIDES_ALL_START,
  MANAGE_RIDES_ALL_SUCCESS,
  MANAGE_RIDES_ALL_ERROR,
  MANAGE_RIDES_ON_TOUR_SUCCESS,
  MANAGE_RIDES_ASSIGNED_SUCCESS,
  MANAGE_RIDES_AVAILABLE_SUCCESS,
  MANAGE_RIDES_MAINTENANCE_SUCCESS,
  GET_PENDING_VERIFICATION_RIDES_START,
  GET_PENDING_VERIFICATION_RIDES_SUCCESS,
  GET_PENDING_VERIFICATION_RIDES_ERROR,
  GET_BULK_UPLOAD_LIST_START,
  GET_BULK_UPLOAD_LIST_SUCCESS,
  GET_BULK_UPLOAD_LIST_ERROR,
  GET_MOTORCYCLE_BY_ID_START,
  GET_MOTORCYCLE_BY_ID_SUCCESS,
  GET_MOTORCYCLE_BY_ID_ERROR,
  GET_REGISTARATION_DETAILS_FROM_CHASIS_START,
  GET_REGISTARATION_DETAILS_FROM_CHASIS_SUCCESS,
  GET_REGISTARATION_DETAILS_FROM_CHASIS_ERROR,
  ADD_MOTORCYCLE_START,
  ADD_MOTORCYCLE_SUCCESS,
  ADD_MOTORCYCLE_ERROR,
  STATE_LIST_SUCCESS,
  STATE_LIST_ERROR,
  UPLOAD_BULK_MOTORCYCLE_START,
  UPLOAD_BULK_MOTORCYCLE_SUCCESS,
  UPLOAD_BULK_MOTORCYCLE_ERROR,
  QUICK_EDIT_MOTORCYCLE_START,
  QUICK_EDIT_MOTORCYCLE_SUCCESS,
  QUICK_EDIT_MOTORCYCLE_ERROR,
  GET_MOTORCYCLE_FAMILY_START,
  GET_MOTORCYCLE_FAMILY_SUCCESS,
  GET_MOTORCYCLE_FAMILY_ERROR,
} from "../Constant/manageRidesConstant";

const initialState = {
  loading: false,
  all: [],
  onTour: [],
  assigned: [],
  maintenance: [],
  available: [],
  pendingVerificationList: [],
  bulkUploadList: [],
  getMotorCyclceById: [],
  getRegisrationDetailsFromChasis: [],
  stateList: [],
  quicEdit: [],
  motorcycleFamily: [],
};

export default function ManageRidesReducer(
  state = { ...initialState },
  action
) {
  switch (action.type) {
    case MANAGE_RIDES_ALL_START:
    case GET_PENDING_VERIFICATION_RIDES_START:
    case GET_BULK_UPLOAD_LIST_START:
    case GET_MOTORCYCLE_BY_ID_START:
    case GET_REGISTARATION_DETAILS_FROM_CHASIS_START:
    case UPLOAD_BULK_MOTORCYCLE_START:
    case QUICK_EDIT_MOTORCYCLE_START:
      return {
        ...state,
        loading: true,
      };
    case MANAGE_RIDES_ALL_SUCCESS:
      return {
        ...state,
        all: action.payload,
        loading: false,
      };
    case MANAGE_RIDES_ON_TOUR_SUCCESS:
      return {
        ...state,
        onTour: action.payload,
        loading: false,
      };
    case MANAGE_RIDES_ASSIGNED_SUCCESS:
      return {
        ...state,
        assigned: action.payload,
        loading: false,
      };
    case MANAGE_RIDES_MAINTENANCE_SUCCESS:
      return {
        ...state,
        maintenance: action.payload,
        loading: false,
      };
    case MANAGE_RIDES_AVAILABLE_SUCCESS:
      return {
        ...state,
        available: action.payload,
        loading: false,
      };
    case GET_PENDING_VERIFICATION_RIDES_SUCCESS:
      return {
        ...state,
        pendingVerificationList: action.payload,
        loading: false,
      };
    case GET_BULK_UPLOAD_LIST_SUCCESS:
      return {
        ...state,
        bulkUploadList: action.payload,
        loading: false,
      };
    case ADD_MOTORCYCLE_START:
      return {
        ...state,
        mlocationLoading: true,
      };
    case ADD_MOTORCYCLE_SUCCESS:
      return {
        ...state,
        addMotorcycle: action.payload,
        mlocationLoading: false,
      };
    case ADD_MOTORCYCLE_ERROR:
      return {
        ...state,
        mlocationLoading: false,
      };
    case GET_MOTORCYCLE_BY_ID_SUCCESS:
      return {
        ...state,
        getMotorCyclceById: action.payload,
        loading: false,
      };
    case GET_REGISTARATION_DETAILS_FROM_CHASIS_SUCCESS:
      return {
        ...state,
        getRegisrationDetailsFromChasis: action.payload,
        loading: false,
      };
    case STATE_LIST_SUCCESS:
      return {
        ...state,
        stateList: action.payload,
        loading: false,
      };
    case UPLOAD_BULK_MOTORCYCLE_SUCCESS:
      return {
        ...state,
        uploadBulkMotorcycle: action.payload,
        motorcycleLoading: false,
      };
    case QUICK_EDIT_MOTORCYCLE_SUCCESS:
      return {
        ...state,
        quicEdit: action.payload,
        loading: false,
      };
    case GET_MOTORCYCLE_FAMILY_SUCCESS:
      return {
        ...state,
        motorcycleFamily: action.payload,
        loading: false,
      };
    case UPLOAD_BULK_MOTORCYCLE_ERROR:
    case MANAGE_RIDES_ALL_ERROR:
    case GET_PENDING_VERIFICATION_RIDES_ERROR:
    case GET_BULK_UPLOAD_LIST_ERROR:
    case GET_MOTORCYCLE_BY_ID_ERROR:
    case GET_REGISTARATION_DETAILS_FROM_CHASIS_ERROR:
    case STATE_LIST_ERROR:
    case QUICK_EDIT_MOTORCYCLE_ERROR:
    case GET_MOTORCYCLE_FAMILY_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    default:
      return state;
  }
}
